import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { DBCheckBox, DBTextArea, DBDropDown } from '_components';
import styles from './Common.module.css';
import { fixCommas, getDateMDYYYY } from '_helpers';

class PatientCareCenterNoteNewAssessment extends React.Component {

    getAssessmentSentence() {
        let flagLimitations = Object.keys(this.props.selectedFlagLimitations).map(key => this.props.selectedFlagLimitations[key].AFFLAGTEXT).join(', ');
        if (this.props.ass.ASFREEFORM) {
            this.props.selectedFlagLimitations.length > 0 ? flagLimitations += ', ' + this.props.ass.ASFREEFORM : flagLimitations += this.props.ass.ASFREEFORM;
        }
        flagLimitations = fixCommas(flagLimitations);

        let goalDifficulties = Object.keys(this.props.selectedGoalDifficulties).map(key => this.props.selectedGoalDifficulties[key].label).join(', ');
        if (this.props.ass.ASDIFFICULTYTXT) {
            this.props.selectedGoalDifficulties.length > 0 ? goalDifficulties += ', ' + this.props.ass.ASDIFFICULTYTXT : goalDifficulties += this.props.ass.ASDIFFICULTYTXT;
        }
        goalDifficulties = fixCommas(goalDifficulties);

        let sentence = "";
        sentence += 'Patient presents with limitations in ';
        sentence += flagLimitations ? flagLimitations : '[limitation(s)]';
        sentence += ' that is contributing to difficulty with ';
        sentence += goalDifficulties ? goalDifficulties : '[goal(s)]';
        sentence += ', therefore the skills of a therapist are warranted in order to ';
        sentence += this.props.ass.ASSKILLS ? this.props.ass.ASSKILLS : '[skillset]';
        sentence = sentence.endsWith('.') ? sentence : sentence += '.';
        return sentence;
    }

    selectAllClicked(val) {
        this.props.updateAllShortGoalFlags(this.props.noteId, this.props.ass.ASNO, val, 'short');
    }

    selectAllGoalsClicked(val) {
        this.props.updateAllGoalFlags(this.props.noteId, this.props.ass.ASNO, val, 'limit');
    }

    render() {
        return (
            <div className={styles.body_wrapper}>
                <span className={styles.row}>
                </span>

                {this.props.isPeds &&
                    <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTASSESSMENT'
                        entityKeyColumn='ASNO'
                        entityKeyValue={this.props.asno}
                        field='ASCOTRT'
                        label="Record co-treatment"
                    />

                }
                {this.props.coTrt &&
                    <div>
                        <div className={styles.textarea_row}>
                            <label className={styles.requiredCoTrt}>With Whom:&nbsp;</label>
                            <DBDropDown
                                noteId={this.props.noteId}
                                entity={'PTASSESSMENT'}
                                entityKeyColumn={'ASNO'}
                                entityKeyValue={this.props.asno}
                                field={'ASCOTRTURNO'}
                                className={styles.supv_dropdown}
                                customOptions={this.props.supvOptions}
                            />
                        </div>
                        <div className={styles.textarea_row}>
                            <label className={styles.requiredCoTrt}>Details:&nbsp;</label>
                            <DBTextArea
                                noteId={this.props.noteId}
                                entity='PTASSESSMENT'
                                entityKeyColumn='ASNO'
                                entityKeyValue={this.props.ass.ASNO}
                                field='ASCOTRTDETAILS'
                                placeholder='Enter details here'
                                className={styles.textarea_col}
                            />
                        </div>
                    </div>
                }
                {this.props.isPeds &&
                    <div>
                        <label className={styles.required}>Caregiver Level of Participation:&nbsp;</label>
                        <div className={styles.row}>
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTASSESSMENT'
                                entityKeyColumn='ASNO'
                                entityKeyValue={this.props.asno}
                                field='ASCOTRTOBSERVED'
                                label="Caregiver observed"
                            />
                        </div>
                        <div className={styles.row}>
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTASSESSMENT'
                                entityKeyColumn='ASNO'
                                entityKeyValue={this.props.asno}
                                field='ASCOTRTNOPARTICE'
                                label="Caregiver did not participate"
                            />
                        </div>
                        <div className={styles.row}>
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTASSESSMENT'
                                entityKeyColumn='ASNO'
                                entityKeyValue={this.props.asno}
                                field='ASCOTRTREVIEWEDGOALS'
                                label="Reviewed HEP or exercises with caregiver"
                            />
                        </div>
                        <div className={styles.row}>
                            <DBCheckBox
                                noteId={this.props.noteId}
                                entity='PTASSESSMENT'
                                entityKeyColumn='ASNO'
                                entityKeyValue={this.props.asno}
                                field='ASCOTRTREVIEWEDSUMMARY'
                                label="Session summary reviewed with caregiver"
                            />
                        </div>
                    </div>
                }


                <DBTextArea
                    noteId={this.props.noteId}
                    entity='PTASSESSMENT'
                    entityKeyColumn='ASNO'
                    entityKeyValue={this.props.ass.ASNO}
                    field='ASFREEFORM'
                    placeholder='Talk about skills delivered today and why more therapy is warranted'
                    className={this.props.isPlanRequired ? styles.textarea : styles.textarea_not_required}
                />
                <span className={styles.spacer}></span>

                <span className={styles.spacer}></span>


                {this.props.isBMITIFEnabled &&
                    <span className={styles.row}>
                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field='ASNUTCOUNSEL'
                            label="Patient was referred to nutrition counseling for abnormal BMI when appropriate"
                        />

                        <span className={styles.row}>
                        </span>

                        <DBCheckBox
                            noteId={this.props.noteId}
                            entity='PTASSESSMENT'
                            entityKeyColumn='ASNO'
                            entityKeyValue={this.props.asno}
                            field='ASTOBFREEFL'
                            label="Patient was referred to Tobacco Free Florida for cessation of tobacco products when appropriate"
                        />
                    </span>
                }
                <span className={styles.spacer}></span>


                {this.props.prevAss && Date.parse(this.props.prevAss.DOS) > Date.parse('01/01/1970') &&
                    <div className={styles.row}>
                        <label className={styles.prev_ass_label}>{getDateMDYYYY(this.props.prevAss.DOS) + ' Assessment'}</label>
                        <label className={styles.prev_ass}>{this.props.prevAss.ASSESSMENT}</label>
                    </div>
                }


            </div >
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        clearField: bindActionCreators(noteActions.clearField, dispatch),
        updateBitField: bindActionCreators(noteActions.updateBitField, dispatch),
        updateAllAssessmentFlags: bindActionCreators(noteActions.updateAllAssessmentFlags, dispatch),
        updateAllGoalFlags: bindActionCreators(noteActions.updateAllGoalFlags, dispatch),
        updateAllShortGoalFlags: bindActionCreators(noteActions.updateAllShortGoalFlags, dispatch),
    };
}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let epno = noteType === 1 ? state.entities.notes.PTEVAL[pk].EVEPNO : state.entities.notes.PTNOTE[pk].NTEPNO;
    let isPedsEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['PTERO_PEDS_ENABLED'].PRVALUE === 'true' : false;
    let isBMITIFEnabled = state.entities.masterData.PROPS ? state.entities.masterData.PROPS['BMI_TFF_ENABLED'].PRVALUE === 'true' : false;
    let isPeds = state.entities.admissions[epno].isPeds && isPedsEnabled;
    let asno = parseInt(Object.keys(state.entities.notes.PTASSESSMENT)
        .find(key => (state.entities.notes.PTASSESSMENT[key].ASEVNO === pk && noteType === 1)
            || (state.entities.notes.PTASSESSMENT[key].ASNTNO === pk && noteType !== 1)));
    let ass = state.entities.notes.PTASSESSMENT[asno];
    let diagVal = state.entities.notes.PTASSESSMENT[asno].ASAWAREDIAG !== null ? state.entities.notes.PTASSESSMENT[asno].ASAWAREDIAG === true ? '1' : '2' : undefined;
    let flags = Object.keys(state.entities.notes.PTASSESSMENTFLAGS)
        .filter(key => {
            return state.entities.notes.PTASSESSMENTFLAGS[key].AFASNO === asno;
        })
        .sort((a, b) => { return state.entities.notes.PTASSESSMENTFLAGS[a].AFNO - state.entities.notes.PTASSESSMENTFLAGS[b].AFNO; })
        .map(key => state.entities.notes.PTASSESSMENTFLAGS[key]);

    let selectedFlagLimitations = Object.keys(state.entities.notes.PTASSESSMENTFLAGS)
        .filter(key => {
            return state.entities.notes.PTASSESSMENTFLAGS[key].AFASNO === asno && state.entities.notes.PTASSESSMENTFLAGS[key].AFLIMITATION === true;
        })
        .sort((a, b) => { return state.entities.notes.PTASSESSMENTFLAGS[a].AFNO - state.entities.notes.PTASSESSMENTFLAGS[b].AFNO; })
        .map(key => state.entities.notes.PTASSESSMENTFLAGS[key]);

    let selectedShortGoals = Object.keys(state.entities.notes.PTSHORTGOALS)
        .filter(key => ((state.entities.notes.PTSHORTGOALS[key]?.SGEVNO === pk && noteType === 1) || (state.entities.notes.PTSHORTGOALS[key].SGNTNO === pk && noteType !== 1))
            && state.entities.notes.PTSHORTGOALS[key].SGACTIVE === true && state.entities.notes.PTSHORTGOALS[key].SGASSESSMENT === true)



    let goals = Object.keys(state.entities.notes.PTGOALS)
        .filter(key => ((state.entities.notes.PTGOALS[key].GOEVNO === pk && noteType === 1) || (state.entities.notes.PTGOALS[key].GONTNO === pk && noteType !== 1))
            && state.entities.notes.PTGOALS[key].GODELETED !== true
            && (state.entities.notes.PTGOALS[key].GOMGNO || state.entities.notes.PTGOALS[key].GOCUSTOM))
        .sort((a, b) => { return state.entities.notes.PTGOALS[a].GONO - state.entities.notes.PTGOALS[b].GONO; })
        .map(key => {
            let label = '';
            if (state.entities.notes.PTGOALS[key].GOCUSTOM) {
                label = state.entities.notes.PTGOALS[key].GOCUSTOM;
            } else {
                label = state.entities.masterData.PTMASTERGOALS[
                    Object.keys(state.entities.masterData.PTMASTERGOALS)
                        .find(key2 => (state.entities.masterData.PTMASTERGOALS[key2].MGNO === state.entities.notes.PTGOALS[key].GOMGNO))].MGASSESSMENT;
                if (label === 'performing essential job demand' && state.entities.notes.PTGOALS[key].GOWORKTASK) {
                    label += ' (' + state.entities.notes.PTGOALS[key].GOWORKTASK + ')';
                }
            }
            return {
                GONO: state.entities.notes.PTGOALS[key].GONO,
                GODIFFICULT: state.entities.notes.PTGOALS[key].GODIFFICULT,
                GOOBJECTIVE: state.entities.notes.PTGOALS[key].GOOBJECTIVE,
                GOCLOF: state.entities.notes.PTGOALS[key].GOCLOF,
                label: label,
                goalOptions: Object.keys(state.entities.masterData.PTMASTERGOALLEVELS)
                    .filter(x => {
                        return (Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
                            .filter(x => {
                                return (state.entities.masterData.PTMASTERGOALLEVELXREF[x].GLXMGNO === state.entities.notes.PTGOALS[key].GOMGNO);
                            })
                            .map(x => state.entities.masterData.PTMASTERGOALLEVELXREF[x].GLXGLNO).includes(state.entities.masterData.PTMASTERGOALLEVELS[x].GLNO));
                    })
                    .sort((a, b) => {
                        let aKey = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
                            .find(x => {
                                return state.entities.masterData.PTMASTERGOALLEVELXREF[x].GLXMGNO === state.entities.notes.PTGOALS[key].GOMGNO &&
                                    state.entities.masterData.PTMASTERGOALLEVELXREF[x].GLXGLNO === state.entities.masterData.PTMASTERGOALLEVELS[a].GLNO
                            });
                        let aOrder = state.entities.masterData.PTMASTERGOALLEVELXREF[aKey].GLXORDER;

                        let bKey = Object.keys(state.entities.masterData.PTMASTERGOALLEVELXREF)
                            .find(x => {
                                return state.entities.masterData.PTMASTERGOALLEVELXREF[x].GLXMGNO === state.entities.notes.PTGOALS[key].GOMGNO &&
                                    state.entities.masterData.PTMASTERGOALLEVELXREF[x].GLXGLNO === state.entities.masterData.PTMASTERGOALLEVELS[b].GLNO
                            });
                        let bOrder = state.entities.masterData.PTMASTERGOALLEVELXREF[bKey].GLXORDER;

                        return aOrder - bOrder;
                    })
                    .map(key => {
                        return {
                            id: state.entities.masterData.PTMASTERGOALLEVELS[key].GLNO,
                            value: state.entities.masterData.PTMASTERGOALLEVELS[key].GLNAME,
                            sentence: state.entities.masterData.PTMASTERGOALLEVELS[key].GLSENTENCETXT,
                            clofOnly: state.entities.masterData.PTMASTERGOALLEVELS[key].GLCLOFONLY,
                        }
                    })
            };
        });

    let shortGoals = Object.keys(state.entities.notes.PTSHORTGOALS)
        .filter(key => ((state.entities.notes.PTSHORTGOALS[key]?.SGEVNO === pk && noteType === 1) || (state.entities.notes.PTSHORTGOALS[key].SGNTNO === pk && noteType !== 1))
            && state.entities.notes.PTSHORTGOALS[key].SGACTIVE === true)
        .sort((a, b) => { return state.entities.notes.PTSHORTGOALS[a].SGNO - state.entities.notes.PTSHORTGOALS[b].SGNO; })
        .map(key => {
            let label = '';
            if (state.entities.notes.PTSHORTGOALS[key].SGNAME) {
                label = state.entities.notes.PTSHORTGOALS[key].SGNAME;
            } else if (state.entities.notes.PTSHORTGOALS[key].SGDESC) {
                label = state.entities.notes.PTSHORTGOALS[key].SGDESC;
            }
            else {
                label = '<not defined>';
            }
            return {
                SGNO: state.entities.notes.PTSHORTGOALS[key].SGNO,
                SGASSESSMENT: state.entities.notes.PTSHORTGOALS[key].SGASSESSMENT,
                SGDESC: state.entities.notes.PTSHORTGOALS[key].SGDESC,
                label: label

            };
        });

    let selectedGoalDifficulties = Object.keys(goals)
        .filter(key => {
            return (goals[key].GODIFFICULT === true);
        })
        .map(key => goals[key]);

    let prevAssKey = Object.keys(state.entities.notes.PTASSESSMENTPREV)
        .find(key => {
            return (state.entities.notes.PTASSESSMENTPREV[key].NoteId === noteId);
        });
    let prevAss = prevAssKey ? state.entities.notes.PTASSESSMENTPREV[prevAssKey] : undefined;

    let pedsEnabled = state.entities.masterData.PROPS['SAPPHIRE_PEDS_ENABLED'].PRVALUE === 'true' ? true : false;

    let coTrt = ass.ASCOTRT ? true : false;

    let supvOptions = Object.keys(state.entities.notes.SUPV)
        .filter(key => state.entities.notes.SUPV[key].EPNO === epno)
        .sort((a, b) => {
            let val = state.entities.notes.SUPV[a].THFNAME.localeCompare(state.entities.notes.SUPV[b].THFNAME) === 0 ?
                state.entities.notes.SUPV[a].THLNAME.localeCompare(state.entities.notes.SUPV[b].THLNAME) :
                state.entities.notes.SUPV[a].THFNAME.localeCompare(state.entities.notes.SUPV[b].THFNAME);
            return val;
        })
        .map(key => (
            {
                id: state.entities.notes.SUPV[key].THNO,
                value: state.entities.notes.SUPV[key].THFNAME + ' ' + state.entities.notes.SUPV[key].THLNAME,
            }
        ));

    let plno = parseInt(Object.keys(state.entities.notes.PTPLAN)
        .find(key => (state.entities.notes.PTPLAN[key].PLEVNO === pk && noteType === 1)
            || (state.entities.notes.PTPLAN[key].PLNTNO === pk && noteType !== 1)));
    let plan = state.entities.notes.PTPLAN[plno];
    let isPlanRequired = true;
    if (plan.PLDISCHARGEREASON !== undefined && plan.PLDISCHARGEREASON !== null) {
        isPlanRequired = plan.PLDISCHARGEREASON.trim() !== 'DNR';
    }


    return {
        noteId,
        noteType,
        ass,
        isPeds,
        diagVal,
        flags,
        selectedFlagLimitations,
        goals,
        shortGoals,
        selectedGoalDifficulties,
        isBMITIFEnabled,
        asno,
        prevAss,
        selectedShortGoals,
        pedsEnabled,
        coTrt,
        supvOptions,
        isPlanRequired
    };
}

const connectedPatientCareCenterNoteNewAssessment = connect(mapStateToProps, mapDispatchToProps)(PatientCareCenterNoteNewAssessment);
export { connectedPatientCareCenterNoteNewAssessment as PatientCareCenterNoteNewAssessment };

